<template>
  <div id="domains-donate">
    <v-container v-if="selection === 0">
      <v-card class="rounded-xl" elevation="7">
        <v-container>
          <v-card-title>Select an Option</v-card-title>
          <v-card-subtitle
            >If you'd like access to your DNS records so you can make added
            modifications, select "Cloudflare Advanced DNS"
          </v-card-subtitle>
          <v-card-actions>
            <v-btn class="card rounded-xl" @click="selection = 1"
              >Cloudflare Automatic DNS
            </v-btn>
            <v-btn class="card rounded-xl" disabled @click="selection = 2"
              >Cloudflare Advanced DNS (Coming Soon)
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-container>
    <v-container v-if="selection === 1">
      <v-card class="rounded-xl" elevation="7">
        <v-card-title>Adding a Domain</v-card-title>
        <v-container>
          <v-form class="card">
            <v-text-field
              class="rounded-xl"
              v-model="simple.domain"
              :outlined="!$store.state.site.whitelabel"
              label="Domain Name"
            ></v-text-field>
            <v-card-text v-if="simple.error">{{ simple.error }}</v-card-text>
            <v-btn
              :loading="simple.loading"
              class="card rounded-xl"
              @click="doDonation()"
              >Donate
            </v-btn>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
    <v-container v-if="selection === 3">
      <v-card class="rounded-xl" elevation="7">
        <v-container>
          <v-card-title>Completing Domain Setup</v-card-title>
          <v-form class="card">
            <v-card-text
              >Replace these nameservers:
              <pre
                v-for="nameserver in simple.oldNameservers"
                :key="nameserver"
              ><code>{{nameserver}}</code></pre>
            </v-card-text>
            <v-card-text
              >with these nameservers:
              <pre
                v-for="nameserver in simple.nameservers"
                :key="nameserver"
              ><code>{{nameserver}}</code></pre>
            </v-card-text>
            <v-btn
              class="card rounded-xl"
              @click="$router.push('/domains/manage/' + simple.domain)"
              >Continue
            </v-btn>
          </v-form>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "DomainsDonate",
  data() {
    return {
      selection: 1,
      simple: {
        loading: false,
        domain: "",
        zone: "",
        error: "",
        nameservers: ["ns3.troplo.com", "ns4.troplo.com"],
        oldNameservers: ["ns1.troplo.com", "ns2.troplo.com"]
      }
    }
  },
  methods: {
    doDonation() {
      this.simple.loading = true
      this.axios
        .post("/api/v1/domains/simple/zone/create", {
          domain: this.simple.domain
        })
        .then((res) => {
          this.simple.nameservers = res.data.result.name_servers
          this.simple.oldNameservers = res.data.result.original_name_servers
          this.simple.loading = false
          this.selection = 3
        })
        .catch((e) => {
          this.simple.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {}
}
</script>

<style scoped></style>
